<profile-editor [useLightTheme]="false"></profile-editor>